var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWavePages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "927px",
    height: "261px",
    viewBox: "0 0 927 261",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wave-pages") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wave-pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,3,0,3,0,3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sound-wave",
    transform: "translate(-46.652008, -163.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4547295,0 C300.76944,28.1741824 261.0027,392.341546 366.06976,383.961515 C471.136819,375.580342 438.772739,217.115136 552.622034,211.781766 C666.473613,206.448396 658.450829,415.964022 762.756153,409.869558 C886.963689,402.611741 887.619216,195.782798 973.652008,216.3529",
    id: "Stroke-1",
    stroke: "#18FFFF",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4547295,5.72625698 C295.45238,32.8540734 259.557798,386.166089 362.431083,376.310956 C465.911957,366.398869 436.885873,216.921365 548.805612,214.347093 C660.048094,211.787629 653.891115,414.730259 756.336118,408.724003 C880.228332,401.411248 881.940317,187.693125 973.652008,211.232907",
    id: "Stroke-3",
    stroke: "#1BF9FF",
    strokeWidth: 0.274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4547295,10.3072626 C290.135501,36.543536 258.120203,380.999385 358.792903,369.629343 C460.696828,358.120003 434.988421,219.406183 544.987828,216.951313 C653.568697,214.529556 649.329077,414.676767 749.916116,408.724565 C873.494413,401.315427 876.2641,179.501425 973.652008,206.143038",
    id: "Stroke-5",
    stroke: "#1EF4FF",
    strokeWidth: 0.298
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3092566,16.0335196 C283.673138,41.3013393 255.545555,375.88425 354.00923,363.041487 C454.346098,349.955632 431.854082,217.152354 540.024093,220.107114 C645.965689,223.001387 643.623056,414.601991 742.348293,408.722144 C865.612351,401.236524 869.439832,171.946467 972.506535,201.619607",
    id: "Stroke-7",
    stroke: "#22EEFF",
    strokeWidth: 0.323
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3092566,20.6145251 C278.354626,44.9853697 254.123104,370.648088 350.370702,356.308865 C449.149509,341.590938 429.854757,216.95079 536.206628,222.714853 C639.452744,228.309587 639.059813,414.546728 735.926506,408.720882 C858.876297,401.137672 863.759382,163.678396 972.506535,196.476809",
    id: "Stroke-9",
    stroke: "#25E8FF",
    strokeWidth: 0.347
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3092566,25.1955307 C273.037089,48.5974003 252.708808,364.352812 346.732246,348.569731 C443.963247,332.249148 427.816908,216.142115 532.388297,224.726117 C632.91025,232.977326 634.499183,413.328283 729.503851,407.574738 C852.139492,399.915923 858.080568,154.96652 972.506535,190.799525",
    id: "Stroke-11",
    stroke: "#28E2FF",
    strokeWidth: 0.371
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01831065,30.9217877 C265.426665,53.3552221 249.008862,359.188375 340.800969,341.98236 C436.494189,324.044757 423.448592,216.453434 526.279193,227.882197 C624.048057,238.748553 627.644164,413.256095 720.791094,407.573721 C843.110126,399.83833 850.109282,147.408753 970.215589,186.274321",
    id: "Stroke-13",
    stroke: "#2BDDFF",
    strokeWidth: 0.395
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01831065,36.6480447 C260.108148,58.112472 247.606872,354.01216 337.162985,335.401887 C431.324109,315.835277 421.336111,216.735116 522.459017,231.037878 C617.450666,244.474569 623.081552,413.182728 714.3684,407.572681 C836.373223,399.762034 844.428281,139.861479 970.215589,181.756303",
    id: "Stroke-15",
    stroke: "#2FD7FF",
    strokeWidth: 0.419
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01831065,40.0837989 C254.786855,60.5809532 246.208181,346.531559 333.522379,326.539182 C426.160405,305.327117 419.185734,214.692191 518.63963,231.903725 C610.826387,247.857884 618.517375,410.819854 707.942825,405.281008 C829.633412,397.395291 838.747896,130.035791 970.215589,174.956399",
    id: "Stroke-17",
    stroke: "#32D1FF",
    strokeWidth: 0.444
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01831065,45.8100559 C249.467066,65.3405592 244.814791,341.325633 329.882196,319.973349 C421.003729,297.100629 417.003824,214.899012 514.819286,235.058464 C604.180221,253.476037 613.953199,410.747384 701.518118,405.279756 C822.894294,397.318023 833.066005,122.512084 970.215589,170.453705",
    id: "Stroke-19",
    stroke: "#35CBFF",
    strokeWidth: 0.468
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8728377,51.5363128 C243.000463,70.099679 242.279509,336.104239 325.09659,313.415427 C414.707313,288.864688 413.64702,215.060732 509.854865,238.213885 C596.370402,259.033925 608.243851,410.673729 693.948173,405.278476 C815.010054,397.242071 826.237959,114.999272 969.070116,165.958113",
    id: "Stroke-21",
    stroke: "#38C6FF",
    strokeWidth: 0.492
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8728377,57.2625698 C237.405212,74.8606205 240.613264,330.865336 321.080474,306.866853 C409.082214,280.619725 410.929897,215.171807 505.440181,241.367623 C588.997895,264.526853 602.96907,410.601051 686.711667,405.27705 C807.315477,397.165048 819.587332,107.500198 967.924643,161.473407",
    id: "Stroke-23",
    stroke: "#3BC0FF",
    strokeWidth: 0.516
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8728377,60.698324 C232.089164,77.3874095 239.228001,324.198344 317.443632,298.827961 C403.943967,270.771545 408.678083,213.447766 501.623344,242.83748 C582.315598,268.354229 598.409082,409.399013 680.292855,404.129859 C800.581402,395.916245 813.910655,97.8465474 967.924643,155.02053",
    id: "Stroke-25",
    stroke: "#3FBAFF",
    strokeWidth: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8728377,66.424581 C226.774038,82.1470676 237.841746,318.896378 313.806826,292.262895 C398.808005,262.461371 406.413986,213.427602 497.807886,245.988018 C575.631091,273.712943 593.860793,409.481535 673.874255,404.119181 C793.864774,396.077935 808.233276,90.3311721 967.924643,150.521655",
    id: "Stroke-27",
    stroke: "#42B4FF",
    strokeWidth: 0.565
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8728377,72.150838 C221.456138,86.906721 236.453079,313.581666 310.168542,285.711347 C393.668142,254.141204 404.146255,213.347208 493.989793,249.141475 C568.947106,279.005062 589.299527,409.410378 667.452779,404.117085 C787.131544,396.010373 802.555371,82.8288063 967.924643,146.035342",
    id: "Stroke-29",
    stroke: "#45AFFF",
    strokeWidth: 0.589
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8728377,77.877095 C216.140028,91.6682689 235.06086,308.249066 306.529921,279.168869 C388.526662,245.806329 401.884021,213.196139 490.172487,252.294346 C562.273916,284.22411 584.73898,409.339056 661.03299,404.11485 C780.39769,395.942894 796.879223,75.3414826 967.924643,141.557384",
    id: "Stroke-31",
    stroke: "#48A9FF",
    strokeWidth: 0.613
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8728377,82.4581006 C210.822041,95.2853622 233.663676,301.75156 302.891752,271.49191 C383.379692,236.309933 399.63595,211.828371 486.355399,254.301417 C555.616579,288.224858 580.177329,408.120161 654.610695,402.967349 C773.66116,394.726957 791.199335,66.7223983 967.924643,135.944199",
    id: "Stroke-33",
    stroke: "#4CA3FF",
    strokeWidth: 0.637
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8728377,87.0391061 C205.504716,98.9452921 232.258375,295.991926 299.253255,264.465655 C378.224267,227.306177 397.416216,210.833455 482.536826,256.924575 C548.981472,292.901789 575.616409,408.062063 648.188963,402.964481 C766.926305,394.624543 785.520076,58.014702 967.924643,130.499031",
    id: "Stroke-35",
    stroke: "#4F9DFF",
    strokeWidth: 0.661
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.72736475,93.9106145 C199.040526,104.850697 229.696325,291.7209 294.4693,259.066515 C371.911922,220.024695 394.090085,211.592 477.572995,261.222731 C541.231753,299.068051 569.90799,409.131186 640.621932,404.107258 C759.043981,395.695154 778.695749,51.6670704 966.77917,127.16325",
    id: "Stroke-37",
    stroke: "#5298FF",
    strokeWidth: 0.685
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.72736475,97.3463687 C193.722235,107.323468 228.267935,283.995971 290.831283,250.24052 C366.729301,209.289486 391.961282,208.840191 473.753727,262.085682 C534.665083,301.735703 565.34624,406.762189 634.19789,401.814224 C752.30676,393.327917 773.014315,41.9001312 966.77917,120.40219",
    id: "Stroke-39",
    stroke: "#5592FF",
    strokeWidth: 0.71
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.72736475,103.072626 C188.401397,112.085295 226.822553,278.544316 287.189847,243.716199 C361.527226,200.827182 389.893255,208.306509 469.934666,265.236689 C528.141826,306.638068 560.781313,406.682354 627.774008,401.811536 C745.568668,393.246758 767.333274,34.4390006 966.77917,115.943787",
    id: "Stroke-41",
    stroke: "#598CFF",
    strokeWidth: 0.734
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5818918,108.457514 C181.936876,116.517236 224.216721,272.927289 282.404884,237.009509 C355.158643,192.102567 386.757204,207.478916 464.969778,268.232072 C520.526156,311.38531 555.072773,406.605495 620.205199,401.808531 C737.684479,393.154333 760.507374,26.5581629 965.633697,111.156664",
    id: "Stroke-43",
    stroke: "#5C86FF",
    strokeWidth: 0.758
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5818918,115.780423 C176.615989,122.865576 222.736556,268.793958 278.764732,231.911462 C349.908377,185.079407 384.852768,208.265005 461.149466,272.732943 C514.108418,317.482002 550.507493,407.660002 613.779402,402.951016 C730.945417,394.228896 754.82553,20.8614954 965.633697,108.318824",
    id: "Stroke-45",
    stroke: "#5F81FF",
    strokeWidth: 0.782
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5818918,119.627521 C171.295764,125.744885 221.232278,261.219343 275.12425,223.395045 C344.626807,174.61436 383.042936,205.54837 457.329952,273.778494 C507.750621,320.089012 545.942942,405.277917 607.354167,400.657452 C724.203463,391.863883 749.143173,11.7403941 965.633697,102.047213",
    id: "Stroke-47",
    stroke: "#627BFF",
    strokeWidth: 0.806
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.2909459,124.732845 C163.683162,129.903077 217.414336,255.408034 269.192811,216.524698 C337.019953,165.587368 379.048641,204.360117 451.218538,276.647597 C499.164701,324.6709 539.08653,405.20111 598.638114,400.653358 C715.170801,391.752807 741.170235,3.4894817 963.342751,96.9754831",
    id: "Stroke-49",
    stroke: "#6575FF",
    strokeWidth: 0.831
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.2909459,131.024148 C158.362155,135.244075 215.85979,250.725745 265.550839,210.79743 C331.665867,157.672711 377.453623,204.295135 447.398858,280.684255 C492.933093,330.414537 534.512646,406.166557 592.21127,401.802769 C708.412473,392.57168 735.486574,-3.60817849 963.342751,93.0607939",
    id: "Stroke-51",
    stroke: "#696FFF",
    strokeWidth: 0.855
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.2909459,135.047754 C153.03855,138.315493 214.274517,243.722386 261.908837,202.76245 C326.268273,147.422402 375.97082,201.915216 443.575922,282.439039 C486.764296,333.877923 529.946959,404.952971 585.784523,400.651629 C701.670337,391.328624 729.803251,-13.0021096 963.342751,86.8525989",
    id: "Stroke-53",
    stroke: "#6C6AFF",
    strokeWidth: 0.879
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.2909459,139.101454 C147.716377,141.414171 212.6589,236.701523 258.267023,194.719995 C320.823725,137.137935 374.602342,199.529758 439.755009,284.207238 C480.658874,337.368804 525.38188,403.738042 579.355794,399.499588 C694.928199,390.085 724.118814,-22.3937044 963.342751,80.648118",
    id: "Stroke-55",
    stroke: "#6F64FF",
    strokeWidth: 0.903
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.14547295,145.185237 C141.247108,146.535723 209.866825,231.377539 253.479407,188.526464 C314.1841,128.881148 372.199056,198.972735 434.788279,287.51182 C473.467961,342.23049 519.66863,403.65246 571.782153,399.492461 C687.038836,390.017351 717.288391,-29.1953899 962.197278,76.6806434",
    id: "Stroke-57",
    stroke: "#725EFF",
    strokeWidth: 0.927
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.14547295,150.406237 C135.924134,150.798637 208.186055,225.488537 249.836088,181.626654 C308.638419,119.702918 371.048934,197.750529 430.966044,290.435928 C467.479639,346.920972 515.102194,403.579909 565.354075,399.483158 C680.296287,389.916829 711.603771,-37.4356526 962.197278,71.6275947",
    id: "Stroke-59",
    stroke: "#7658FF",
    strokeWidth: 0.952
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.14547295,155.302338 C130.600512,154.737189 206.471761,219.033967 246.194425,174.306171 C303.038179,110.30053 370.00107,196.074094 427.142949,292.57178 C461.545043,350.66905 510.53473,402.346461 558.923597,398.327627 C673.551171,388.701834 705.917787,-45.3699202 962.197278,66.5180733",
    id: "Stroke-61",
    stroke: "#7953FF",
    strokeWidth: 0.976
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,160.54239 C124.129794,159.018593 203.576427,213.144827 241.405818,167.401192 C296.235988,101.099442 367.897879,194.914132 422.174036,295.503032 C454.514698,355.438671 504.822522,402.269426 551.348206,398.314184 C665.659973,388.597548 699.084674,-53.6042611 961.051805,61.4704284",
    id: "Stroke-63",
    stroke: "#7C4DFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavePages);
export default __webpack_public_path__ + "static/media/wave-pages.57ac07720c610acdbcd3b0c01c65cad3.svg";
export { ForwardRef as ReactComponent };